import { useEffect, useCallback } from 'react';
import { fieldNames } from '../../config';
import {
  shutdownEvtNames as evtNames,
  shutdownEmitter as emitter,
} from '../../../../../shared/constants';

export const useAutoResponseEventsSubscription = ({ form, visible }) => {
  const handleAddOrEditSuccess = useCallback(
    (data) => {
      form.setFieldsValue({
        [fieldNames.alisaText]: data.text,
        [fieldNames.alisaTemplate]: data.id || undefined,
      });
    },
    [form]
  );

  const handleDeleteSuccess = useCallback(
    (templateId) => {
      const fieldName = fieldNames.alisaTemplate;

      if (form.getFieldValue(fieldName) === templateId) {
        form.setFieldsValue({ [fieldName]: undefined });
      }
    },
    [form]
  );

  useEffect(() => {
    if (visible) {
      emitter.on(
        evtNames.autoResponseTemplateAddOrEdit,
        handleAddOrEditSuccess
      );
      emitter.on(evtNames.autoResponseTemplateDelete, handleDeleteSuccess);

      return () => {
        emitter.off(
          evtNames.autoResponseTemplateAddOrEdit,
          handleAddOrEditSuccess
        );
        emitter.off(evtNames.autoResponseTemplateDelete, handleDeleteSuccess);
      };
    }
  }, [visible, handleAddOrEditSuccess, handleDeleteSuccess]);
};
